import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CheckSquare2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
    ['path', { d: 'm9 12 2 2 4-4' }],
  ],
];

export default CheckSquare2;
